import ClientApi from '@src/types/client';
import Api from '@sendsprint/api-types';

export type RecipientTypeOptions = {
  country: Api.Model.CountryInitials;
  paymentType: Api.Model.PaymentType;
};

const RECIPIENT_TYPE_MAPPING: Record<ClientApi.General.RecipientType, RecipientTypeOptions> = {
  [ClientApi.General.RecipientType.NEW_NG_BANK]: {
    country: Api.Model.CountryInitials.NigeriaNig,
    paymentType: Api.Model.PaymentType.BankAcc
  },
  [ClientApi.General.RecipientType.NG_DOM]: {
    country: Api.Model.CountryInitials.Nigeria,
    paymentType: Api.Model.PaymentType.DomAcc
  },
  [ClientApi.General.RecipientType.NG_V_DOM]: {
    country: Api.Model.CountryInitials.Nigeria,
    paymentType: Api.Model.PaymentType.VDomAcc
  },
  /** Auto dom */
  [ClientApi.General.RecipientType.NG_A_DOM]: {
    country: Api.Model.CountryInitials.Nigeria,
    paymentType: Api.Model.PaymentType.ADomAcc
  },
  [ClientApi.General.RecipientType.NG_CASH]: {
    country: Api.Model.CountryInitials.Nigeria,
    paymentType: Api.Model.PaymentType.Cash
  },
  [ClientApi.General.RecipientType.GH_BANK]: {
    country: Api.Model.CountryInitials.Ghana,
    paymentType: Api.Model.PaymentType.BankAcc
  },
  [ClientApi.General.RecipientType.GH_MOBILE]: {
    country: Api.Model.CountryInitials.Ghana,
    paymentType: Api.Model.PaymentType.MobileMoney
  },
  [ClientApi.General.RecipientType.KE_BANK]: {
    country: Api.Model.CountryInitials.Kenya,
    paymentType: Api.Model.PaymentType.BankAcc
  },
  [ClientApi.General.RecipientType.KE_MOBILE]: {
    country: Api.Model.CountryInitials.Kenya,
    paymentType: Api.Model.PaymentType.MobileMoney
  },
  [ClientApi.General.RecipientType.ZA_BANK]: {
    country: Api.Model.CountryInitials.SouthAfrica,
    paymentType: Api.Model.PaymentType.BankAcc
  }
};

export const getRecipientTypeFromMapping = ({
  country,
  paymentType
}: RecipientTypeOptions): ClientApi.General.RecipientType | null => {
  const type = Object.keys(RECIPIENT_TYPE_MAPPING).find((t) => {
    const obj = RECIPIENT_TYPE_MAPPING[t as ClientApi.General.RecipientType];
    return obj.paymentType === paymentType && obj.country === country;
  });

  return (type as ClientApi.General.RecipientType) || null;
};

export const getOptionsFromRecipientType = (
  type: ClientApi.General.RecipientType
): RecipientTypeOptions => {
  return RECIPIENT_TYPE_MAPPING[type];
};
